module.exports = __webpack_public_path__ + "img/教育配套_image.71da1c43.png";